import { render, staticRenderFns } from "./supplierBMCL.vue?vue&type=template&id=225363e4&scoped=true&"
import script from "./supplierBMCL.vue?vue&type=script&lang=js&"
export * from "./supplierBMCL.vue?vue&type=script&lang=js&"
import style0 from "./supplierBMCL.vue?vue&type=style&index=0&id=225363e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225363e4",
  null
  
)

export default component.exports